import React from 'react';
import { ChevronLeft } from 'lucide-react';

const ImprintPage = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 via-gray-100 to-gray-200 dark:from-slate-950 dark:via-slate-950 dark:to-slate-950 flex justify-center py-8">
            <div className="w-full max-w-3xl px-4 lg:px-8">
                <button
                    onClick={() => window.location.hash = '/'}
                    className="inline-flex items-center text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-slate-200 font-medium mb-8 transition-colors"
                >
                    <ChevronLeft size={18} className="mr-1" />
                    Back to Home
                </button>

                <article className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl p-8 md:p-12 border border-gray-200 dark:border-slate-800">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
                        Imprint / Legal Notice
                    </h1>

                    <div className="prose dark:prose-invert max-w-none text-gray-600 dark:text-slate-300 space-y-4">

                        <p>
                            This Imprint provides legally required information about the owner and operator of
                            the BrieflyCA website and mobile application.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            Service Operator
                        </h2>
                        <p>
                            <strong>BrieflyCA</strong><br />
                            Operated by: <strong>BrieflyCA Technologies</strong><br />
                            Email:{" "}
                            <a href="mailto:info@askstudios.ca" className="text-red-600 dark:text-red-400 hover:underline">
                                info@askstudios.ca
                            </a><br />
                            Website:{" "}
                            <a href="https://brieflyca.vercel.app" className="text-red-600 dark:text-red-400 hover:underline">
                                https://brieflyca.vercel.app
                            </a>
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            Responsible for Content
                        </h2>
                        <p>
                            BrieflyCA publishes rewritten news summaries for informational purposes.
                            Original news content belongs to the respective publishers.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            Editorial Independence
                        </h2>
                        <p>
                            BrieflyCA operates independently. We are not affiliated with any news publisher,
                            broadcaster, political entity, or media organization.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            Copyright Notice
                        </h2>
                        <p>
                            All rewritten summaries and UI design within BrieflyCA are © BrieflyCA Technologies.
                            All original news stories, headlines, and images remain the property
                            of their respective copyright holders.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            Liability for Content
                        </h2>
                        <p>
                            While we strive to provide accurate summaries, we cannot guarantee completeness
                            or real-time accuracy. Users should refer to original news sources for
                            full context and verification.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            Contact for Legal Requests
                        </h2>
                        <p>
                            For privacy, copyright, or legal concerns, please contact:
                        </p>
                        <p>
                            📧{" "}
                            <a href="mailto:info@askstudios.ca" className="text-red-600 dark:text-red-400 hover:underline">
                                info@askstudios.ca
                            </a>
                        </p>
                    </div>
                </article>
            </div>
        </div>
    );
};

export default ImprintPage;
